const medilavia_colors = {
  primary: '#40522B', 
  primaryOpacity: '#40522B4D',

  backgroundComponent: '#fff',
  backgroundPage: '#FBF9F8',
  backgroundInput: '#D3D5D7',
  backgroundPromotionStatus: '#CCF4D7',
  backgroundPromotionData: '#EDF8FF',
  backgroundCodeInput: '#ebe9e8',
  backgroundWidget: '#fff',
  backgroundBadge: '#fcd69e',
  
  text0: '#1C1E21',
  text1: '#000000',
  text2: '#6E6A60',
  text3: '#3B3E43',
  text4: '#2B3327',
  subtitle: '#AB9680',
  textDataUpdated: '#647893',
  textPromotionStatus: '#01A72F',
  textPromotionData: '#CCF4D7',
  textPastEntryCard: '#9B9B9B',

  logoName: '#414141',
  
  cardBorder: '#C9C0A8',
  actionLog: '#FFD700',
  inputBorder: '#F6F6F6',
  greetBorder: '#E7F0F5',
}

export default medilavia_colors;